import { createFileRoute } from "@tanstack/react-router";
import { PasswordView } from "@/components/views";
import type { RouterAppContext } from "@/utils/custom-types";

export const Route = createFileRoute("/$workspaceId/passwords/$channelId")({
	component: RouteComponent,
});

function RouteComponent() {
	const { workspaceId, channelId } = Route.useParams();
	const { session, currentWorkspace } =
		Route.useRouteContext() as RouterAppContext;
	
	return (
		<PasswordView
			workspaceId={workspaceId}
			channelId={channelId}
			session={session}
			currentWorkspace={currentWorkspace}
		/>
	);
}
